<template>
  <div>
    <div class="title">如何查看优惠券？</div>
    <div class="content-info">
      <p class="txt1">
        进入商城首页，点击“我的红包”，即可查看“未使用”、“已使用”、“已过期”的优惠券。
        <br />微信端可在“我的”界面直接查看优惠券数量，点击进入可查看“未使用”、 “已使用”、“已过期”的优惠券。
      </p>
      <ul>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/b9476650ca2db6e03228740292985700.png" />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/2960fa03f0de5fd8112d45558bfa1d2c.png" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
